import { ListaPedidosSapQueryDto } from '../../../back/src/pedidos-sap/dto/lista-pedidos-sap-query.dto';
import { ViewPedidoSapResumo } from '@models/views/view-pedido-sap-resumo.model';
import { CriaPedidoSapDto } from '@/../../back/src/pedidos-sap/dto/cria-pedido-sap.dto';
import { CriaPedidoSapOldDto } from '@/../../back/src/pedidos-sap/dto/cria-pedido-sap-old.dto';
import { AtualizaPedidoCompraDto } from '@/../../back/src/pedidos-sap/dto/atualiza-pedido-compra.dto';
import { AtualizaPedidoSapDto } from '@/../../back/src/pedidos-sap/dto/atualiza-pedido-sap.dto';
import { GeraLaudoMultiploPedidoSapQueryDto } from '@/../../back/src/pedidos-sap/dto/gera-laudo-multiplo-pedido-sap-query.dto';
import axios from 'axios';
import { PedidoSap } from '@models/pedido-sap.model';
import { Bag } from '@models/bag.model';
import { AmostraPlaca } from '@models/amostra-placa.model';
import { AmostraUtinga } from '@models/amostra-utinga.model';

const listaPedidosSap = async (): Promise<PedidoSap[]> => {
  const res = await axios.get<PedidoSap[]>(`/pedidos_sap`);
  return res.data;
};

const listaPedidosSapResumo = async (
  queryDto: ListaPedidosSapQueryDto,
): Promise<{
  count: number;
  rows: ViewPedidoSapResumo[];
}> => {
  const res = await axios.get<{ count: number; rows: ViewPedidoSapResumo[] }>(
    '/pedidos_sap/resumo',
    {
      params: queryDto,
    },
  );
  return res.data;
};
const listaBagsPedidoSap = async (pedidoSapId: number): Promise<Bag[]> => {
  const res = await axios.get<Bag[]>(`/pedidos_sap/${pedidoSapId}/bags`);
  return res.data;
};

const listaAmostrasPedidoSap = async (
  pedidoSapId: number,
): Promise<AmostraPlaca[] | AmostraUtinga[]> => {
  const res = await axios.get<AmostraPlaca[] | AmostraUtinga[]>(
    `/pedidos_sap/${pedidoSapId}/amostras`,
  );
  return res.data;
};

const listaNotaFiscalEntrada = async (): Promise<PedidoSap[]> => {
  const res = await axios.get<PedidoSap[]>('/pedidos_sap/nfs_entrada');
  return res.data;
};
const buscaPedidoSap = async (pedidoSapId: number): Promise<PedidoSap> => {
  const res = await axios.get<PedidoSap>(`/pedidos_sap/${pedidoSapId}`);
  return res.data;
};

const cria = async (formData: CriaPedidoSapDto): Promise<PedidoSap> => {
  const res = await axios.post<PedidoSap>('/pedidos_sap', formData);
  return res.data;
};

const criaPedidoOld = async (
  formData: CriaPedidoSapOldDto,
): Promise<PedidoSap> => {
  const res = await axios.post<PedidoSap>('/pedidos_sap/old', formData);
  return res.data;
};

const criaBagPedido = async (
  pedidoSapId: number,
  formData: FormData,
): Promise<Bag> => {
  const res = await axios.post<Bag>(
    `/pedidos_sap/${pedidoSapId}/bag`,
    formData,
  );
  return res.data;
};

const registraPedidoCompra = async (
  pedidoSapId: number,
  formData: AtualizaPedidoCompraDto,
): Promise<PedidoSap> => {
  const res = await axios.patch<PedidoSap>(
    `/pedidos_sap/${pedidoSapId}/registra_pedido`,
    formData,
  );
  return res.data;
};

const atualiza = async (
  pedidoSapId: number,
  formData: AtualizaPedidoSapDto,
): Promise<PedidoSap> => {
  const res = await axios.patch<PedidoSap>(
    `/pedidos_sap/${pedidoSapId}`,
    formData,
  );
  return res.data;
};

const remove = async (pedidoSapId: number): Promise<PedidoSap> => {
  const res = await axios.delete<PedidoSap>(`/pedidos_sap/${pedidoSapId}`);
  return res.data;
};

const geraLaudoMultiploPdf = async (
  pedidoSapId: number,
  queryDto: GeraLaudoMultiploPedidoSapQueryDto,
): Promise<any> => {
  const res = await axios.get(
    `/pedidos_sap/${pedidoSapId}/gera_laudo_multiplo_pdf`,
    {
      params: queryDto,
      responseType: 'arraybuffer',
      responseEncoding: 'binary',
      headers: { 'Content-Type': 'application/pdf' },
    },
  );
  return res.data;
};

export default {
  buscaPedidoSap,
  listaPedidosSap,
  listaPedidosSapResumo,
  listaBagsPedidoSap,
  listaAmostrasPedidoSap,
  listaNotaFiscalEntrada,
  cria,
  criaPedidoOld,
  criaBagPedido,
  registraPedidoCompra,
  atualiza,
  remove,
  geraLaudoMultiploPdf,
};
